export { scrambledCardStyles } from '@utils/component-framework';

const contentWrapper = "jzpc17pavms";
const textBox = "jzpts8wfqh";
const line = "jzpl105os58";

export { contentWrapper, line, textBox };
import "./comp.scrambled.style.linaria.module.css";
//# sourceMappingURL=comp.scrambled.style.js.map
